var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88 6c0 .4.33.74.74.74.21 0 .38.16.38.37v1.34c0 1.13-.93 2.05-2.07 2.05H3.07A2.06 2.06 0 0 1 1 8.45V7.1c0-.2.17-.37.38-.37.4 0 .74-.33.74-.74 0-.4-.32-.7-.75-.7A.38.38 0 0 1 1 4.94V3.55c0-1.13.93-2.05 2.07-2.05h5.86c1.14 0 2.07.92 2.07 2.05V4.9a.37.37 0 0 1-.38.37.74.74 0 0 0-.74.74Zm-2.75.32.59-.56c.1-.1.13-.25.09-.38a.37.37 0 0 0-.3-.25l-.81-.12-.37-.73a.37.37 0 0 0-.66 0l-.37.73-.8.12a.37.37 0 0 0-.3.25c-.05.13-.02.28.08.38l.6.56-.15.8c-.02.15.04.28.15.37a.37.37 0 0 0 .4.02L6 7.14l.73.37c.12.07.27.06.39-.02a.36.36 0 0 0 .15-.36l-.14-.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsmall);
export default __webpack_public_path__ + "static/media/subscription.small.86764f029682e1239c0ff8661f3fbb8e.svg";
export { ForwardRef as ReactComponent };